import PropTypes from 'prop-types';
import { Radio } from '@mantine/core';
import { IconCircleCheckFilled, IconCircle } from '@tabler/icons-react';
import classes from './radioButton.module.css';

const RadioButton = (props) => {
  const {
    options,
    test,
    value,
    disabled = false,
    form,
    onChange,
    fieldName,
    label,
    withAsterisk,
    variant = '',
  } = props;

  const selectedOption = value;
  const handleChange = (val) => {
    if (onChange) {
      onChange(val);
    }
    form.setFieldValue(fieldName, val);
  };
  const wrapperClass = classes[variant];

  return (
    <Radio.Group
      test={test}
      withAsterisk={withAsterisk}
      label={label}
      {...form.getInputProps(fieldName)}
      className={classes.radioGroupContainer}
      onChange={handleChange}
    >
      <div className={`${classes.container} ${wrapperClass}`}>
        {options.map((item) => (
          <Radio.Card
            key={item.value}
            className={classes.root}
            value={item.value}
            disabled={disabled}
            role="radio"
            data-f={item.value}
            aria-checked={selectedOption === item.value}
            aria-disabled={disabled}
            aria-label={item.label}
          >
            <div className={classes.rootContainer}>
              {selectedOption === item.value ? (
                <div className={classes.check}><IconCircleCheckFilled /></div>
              ) : (
                <div className={classes.check}><IconCircle /></div>
              )}

              <div className={classes.icon}>{item.icon}</div>

              <div className={classes.textBlock}>
                <div className={classes.label}>{item.label}</div>
                <div className={classes.description}>{item.description}</div>
              </div>
            </div>
          </Radio.Card>
        ))}
      </div>
    </Radio.Group>
  );
};

RadioButton.propTypes = {
  value: PropTypes.string,
  description: PropTypes.string,
  test: PropTypes.string,
  options: PropTypes.array,
  disabled: PropTypes.bool,
  form: PropTypes.object,
  onChange: PropTypes.func,
  fieldName: PropTypes.string,
  label: PropTypes.string,
  withAsterisk: PropTypes.bool,
  variant: PropTypes.string,
};

export default RadioButton;
